import { AddNewLicenses } from "@/components/settings/AddNewLicenses";
import { createFileRoute, linkOptions } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_dashboard/settings/_admin/subscription/_subscription/add-users",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const context = Route.useRouteContext();

  return (
    <div className="h-full px-14 pb-12">
      <AddNewLicenses
        backLinkOptions={linkOptions({
          from: Route.fullPath,
          to: "/settings/subscription",
        })}
        context={context as Required<typeof context>}
      />
    </div>
  );
}
